var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CORPUS_CHECK_CODES } from '../../types/quality';
import { corpusCheckGroup } from './corpusCheckLabels';
/** How many of the largest checks the "Nejvíc nálezů" strip lists. */
export var TOP_CHECKS = 3;
/** Tie order of groups with the same total — the order the faults were described in. */
var GROUP_ORDER = [
    'oneSided', 'contradicting', 'target', 'duplicate', 'unlinkedValue', 'wrongSubfield', 'other',
];
var codeRank = function (code) {
    var at = CORPUS_CHECK_CODES.indexOf(code);
    return at === -1 ? CORPUS_CHECK_CODES.length : at;
};
/** Most findings first; a tie keeps the backend's code order, an unknown code last. */
export var byFindingsDesc = function (a, b) { return (b.findings - a.findings || codeRank(a.code) - codeRank(b.code) || a.code.localeCompare(b.code)); };
/**
 * The checks of the overview (CZNA-1407): grouped by kind of fault, the group with the
 * most findings first and, inside a group, the check with the most findings first. The
 * backend still returns them by code (`CorpusCheckStore`); the order is the screen's.
 */
export var groupChecks = function (checks) {
    var groups = new Map();
    checks.forEach(function (c) {
        var _a;
        var group = corpusCheckGroup(c.code);
        groups.set(group, __spreadArray(__spreadArray([], ((_a = groups.get(group)) !== null && _a !== void 0 ? _a : []), true), [c], false));
    });
    return Array.from(groups.entries())
        .map(function (_a) {
        var group = _a[0], rows = _a[1];
        return ({
            group: group,
            findings: rows.reduce(function (sum, r) { return sum + r.findings; }, 0),
            rows: __spreadArray([], rows, true).sort(byFindingsDesc),
        });
    })
        .sort(function (a, b) { return b.findings - a.findings || GROUP_ORDER.indexOf(a.group) - GROUP_ORDER.indexOf(b.group); });
};
/** The largest checks regardless of group — where to start. A check without findings is never one. */
export var topChecks = function (checks) { return (checks.filter(function (c) { return c.findings > 0; }).sort(byFindingsDesc).slice(0, TOP_CHECKS)); };
